// The backend address is baked into the JavaScript at build time from
// REACT_APP_BACKEND_URL. If a build ever runs without that value set, every API
// call resolves to a relative path on the site's own domain, Apache answers
// with index.html, and the page gets HTML where it expected JSON — which on
// screen looks exactly like "there is no data". Nothing errors visibly.
//
// The fallback below makes that silent failure impossible.
const FALLBACK = "https://coach-oj.onrender.com";

const base = (process.env.REACT_APP_BACKEND_URL || FALLBACK).replace(/\/+$/, "");

if (!process.env.REACT_APP_BACKEND_URL && typeof console !== "undefined") {
  console.warn("REACT_APP_BACKEND_URL was not set at build time; using " + FALLBACK);
}

export const API = `${base}/api`;
export default API;
